import router from '@/router'
import store from '@/store';
import {_post, _get} from "@/assets/js/http.js"
import { setStorage, getStorage, getUrlParam, removeStorage, checkBrowser, GetUrlRelativePath} from "@/assets/js/util2.js"
import util from "@/assets/js/util.js"
import Vue from 'vue'
const wx = require('weixin-js-sdk')
const client_type = checkBrowser()//微信/支付宝环境
Vue.prototype.userInfo = null

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  // let urlArray = ['/binding']
  // if (client_type === 'wechat') {
  //   if (urlArray.includes(to.path)) {
  //     console.log(`${Vue.prototype.mifiUrl}${to.path}`)
  //     _get("/rechargeApi/v1/app/xinxun_sign_info", {
  //       url: location.href.split('#')[0]
  //     })
  //     .then(function(res) {
  //       wx.config({
  //         debug: false,
  //         appId: res.data.data.appId,
  //         timestamp: res.data.data.timestamp,
  //         nonceStr: res.data.data.noncestr,
  //         signature: res.data.data.sign,
  //         jsApiList: ["scanQRCode"],
  //         openTagList: ["wx-open-launch-weapp"]
  //       });
  //     });
  //   }
  // }
})

// 解决ios微信分享bug
router.beforeEach( async (to, from, next) => {

  // 对组件进行动态缓存
	if (to.meta.keepAlive) {
		store.commit('iskeepAlive', to.name);
	}

  if(location.href.indexOf('activity') != -1 && location.href.indexOf('?') != -1) {
    var query = {};
    location.search.substring(1).split('&').forEach(item => {
      var items = item.split("=")
      if(items[1]) {
        query[items[0]] =  +items[1] == items[1] ? +items[1] : decodeURIComponent(items[1])
      }
    })
    setStorage('query', JSON.stringify(query))
  }

  if (!to.meta.login && to.meta.login != false && !getUrlParam('hidePay')) {
    if (client_type == 'wechat' || client_type == 'alipay') {
      if (getStorage('token')) {
        if (!Vue.prototype.userInfo) {
          getUserInfo(to)
          next()
        } else {
          next()
        }
      } else {

        if (to.path.indexOf('notPhoneLogin') != -1) {
          // 不需要手机号登录 便可获取用户信息
          const url_notPhoneLogin = await authorizedRediect_noPhoneLogin()
          location.href = url_notPhoneLogin
        } else {
          const url = await authorizedRediect()
          location.href = url
        }

      }
    } else {
      next()
    }
  } else {
    next()
  }

})


function getUserInfo (to) {
  return new Promise((resolve) => {
    _get("/accountCenter/v2/user/info?" + util.carsParam({}, 'get'))
      .then(res => {
        if (res.data.error === 0) {
          if (res.data.data && JSON.stringify(res.data.data) !== '{}') {
            Vue.prototype.userInfo = res.data.data
            setStorage("userCenterInfo", res.data.data, "obj")
            if (to.path.indexOf('notPhoneLogin') != -1) return
            getGold()
          } else {
            Notify({message: '请求失败'})
          }
        } else if (res.data.error === 11002) {
          refreshToken()
        } else if (res.data.error === 10007) {
          let curTimeStamp = (Date.parse(new Date()) / 1000),
            timeSpan = res.data.extra - curTimeStamp;
          setStorage('timeSpan', timeSpan);
          getUserInfo()
        } else if (res.data.error === 20014) {
          Notify({message: '请求超时'})
        } else {
          Notify({message: res.data.msg})
        }
        resolve()
      })
  })
}

function authorizedRediect () {
  const state = Math.random().toString(36).substr(2) + new Date().getTime()
  setStorage('state', state)
  setStorage('authorized_redirect_uri', GetUrlRelativePath())
  return new Promise((resolve, reject) => {
    _get('/accountCenter/v2/oauth/authorize?' + util.carsParam({
      client_type: client_type,
      redirect_uri:  Vue.prototype.mifiUrl+ '/mifi/authority',
      scope: 'userinfo',
      state: state
    }))
    .then(res => {
      resolve(res.data.data)
    })
  })
}

function authorizedRediect_noPhoneLogin () {
  const state = Math.random().toString(36).substr(2) + new Date().getTime()
  setStorage('state', state)
  setStorage('authorized_redirect_uri', GetUrlRelativePath())
  setStorage('imei', getUrlParam('imei'))
  return new Promise((resolve, reject) => {
    _get('/accountCenter/v2/oauth/authorize-new?' + util.carsParam({
      client_type: client_type,
      redirect_uri:  Vue.prototype.mifiUrl+ '/mifi/authority_noPhoneLogin',
      scope: 'userinfo',
      state: state
    }))
    .then(res => {
      resolve(res.data.data)
    })
  })
}

function refreshToken() {
  _get("/accountCenter/v2/auth/refresh?" + util.carsParam({
    token: getStorage('token')
  }, 'get'))
    .then((res) => {
      if (res.data.error === 0) {
        setStorage('token', res.data.data);
        getUserInfo()
      }
    })
}

/**
 * 金币登录
 */
function getGold () {
  var { user_id } = JSON.parse(getStorage("userCenterInfo")).account;
  var { age, gender, nickname, mobile, created } = JSON.parse(getStorage("userCenterInfo"));
  var { headimgurl } = JSON.parse(getStorage("userInfo"));
  // console.log(user_id, age, gender, nickname, mobile, headimgurl)
  var requestData = {
      user_id: user_id,
      age: age,
      gender: gender,
      nickname: btoa(encodeURI(nickname)),
      mobile: mobile,
      portrait: headimgurl,
      created: created
  }
  _post("/rechargeApi/v1/app/users/login", requestData).then(res => {
      const data = res.data.data;
      if(res.data.state == 1) {
          // this.myGold = data.gold;
          // if (this.myGold >= 100000000) {
          //     this.myGold = (this.myGold / 100000000).toFixed(2) + '亿'
          // }
      }
  })
}